// libs
import React, { memo, useContext, useState, useEffect, useMemo } from 'react';
import get from 'lodash/get';

// helpers
import { getCarouselImages } from 'shared/components/AdPlatformWidgets/helpers';

// types
import { ILandingPageWidget } from 'shared/components/AdPlatformWidgets/types';

// context
import ResponsiveContext from 'shared/components/ResponsiveLoader/ResponsiveContext';

// components
import ImageCarousel from './components/ImageCarousel';
import CarouselWrapper from 'shared/components/Carousel';
import NavButton from './NavButton';

// constants
import { PLACE_HOLDER_COLORS } from 'shared/components/AdPlatformWidgets/constants';
import { CAROUSEL } from 'shared/components/AdPlatformWidgets/constants';

// styles
import { CarouselContainer, Placeholder, Dots } from './styles';

// def
import { IMapOfString } from 'global';
interface ICarouselProps {
  widget: ILandingPageWidget;
}

function Carousel({ widget }: ICarouselProps) {
  const inventoryName = get(widget, 'inventory_name', '');
  const [selectedImage, setSelectedImage] = useState(0);
  const [showPlaceholder, setShowPlaceholder] = useState(true);

  const { deviceWidth } = useContext(ResponsiveContext);
  const delayTimer = get(widget, 'widget_data.parameters.delay_timer', 5000);

  useEffect(() => {
    setShowPlaceholder(false);
  }, []);

  const carouselImageArray = useMemo(() => {
    const options = {
      urlSource: CAROUSEL.URL_SOURCE_DESKTOP,
      aspectRatioSrc: CAROUSEL.ASPECT_RATIO_SOURCE_DESKTOP,
      defaultAspectRatio: CAROUSEL.DEFAULT_ASPECT_RATIO_DESKTOP,
    };
    return getCarouselImages({
      widget,
      options,
      inventoryName,
    });
  }, [inventoryName, widget]);

  const aspectRatio = carouselImageArray[0].aspect_ratio;
  const slideWidth = deviceWidth;
  const slideHeight = slideWidth / aspectRatio;

  const marginTop = get(widget, 'widget_data.parameters.margin_top');

  if (showPlaceholder) {
    return (
      <Placeholder
        marginTop={marginTop}
        bgColor={PLACE_HOLDER_COLORS.BEIGE}
        aspectRatio={aspectRatio}
      />
    );
  }

  return (
    <CarouselContainer marginTop={marginTop}>
      <CarouselWrapper
        slideWidth={slideWidth}
        slideHeight={slideHeight}
        currentSlide={selectedImage}
        onChange={setSelectedImage}
        navPadding={0}
        nextButton={<NavButton type="next" />}
        prevButton={<NavButton type="prev" />}
        autoPlayDuration={delayTimer < 5000 ? 5000 : delayTimer}
        navCustomStyles={{ minWidth: '30px' }}
        loopOverSlides
        showNav
        autoPlay
      >
        {carouselImageArray.map((img: IMapOfString, idx: number) => {
          return (
            <ImageCarousel
              deviceWidth={deviceWidth}
              slideHeight={slideHeight}
              slideWidth={slideWidth}
              img={img}
              key={idx}
            />
          );
        })}
      </CarouselWrapper>
      <Dots
        numberOfSlides={carouselImageArray.length}
        currentSlide={selectedImage}
        onSelect={setSelectedImage}
      />
    </CarouselContainer>
  );
}
export default memo(Carousel);
